import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import FilterBar from './filterBar';
import ChannelActionsTable from './channelActionsTable/channelActionsTable';
import { getChannelActions } from '../../../../redux/thunks/adminSettingsThunk'
const ChannelActions = () => {
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.company);

  useEffect(() => {
    if (company.id) {
      dispatch(getChannelActions({ companyId: company.id }))
    }

  }, [company.id])

  return (
    <>
      <FilterBar />
      <Grid container>
        <Grid item xs={12}>
          <ChannelActionsTable />
        </Grid>
      </Grid>
    </>

  )
}

export default ChannelActions
